import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Card from '../../../Card';
import BaseSkeleton from '../BaseSkeleton';

import { BannerSkeletonProps } from './BannerSkeleton.types';

import './BannerSkeleton.scss';

const BannerSkeleton: React.FC<BannerSkeletonProps> = ({
  className,
  strip,
  loading = false,
}) => {
  return (
    <div className='flex flex-column'>
    <Card className={`flex p4 ${className}`} strip={strip} loading={loading} >
      <Skeleton variant="circle" className="banner-skeleton mr4" height={90} width={90} />
      <div className="flex flex-column">
        <BaseSkeleton className="mb2" height={30} width={200} />
        <BaseSkeleton className="mb1" width={200} />
        <div className='flex flex-row'>
          <BaseSkeleton className="mb1 mr3" height={55} width={100} />
          <BaseSkeleton className="mb1" height={55} width={100} />
        </div>       
      </div>
    </Card>
    </div>
  );
};

export default BannerSkeleton;
export { BannerSkeletonProps };
